import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export async function validateReactivation({
  msisdn,
  iccid,
}: {
  msisdn: string | null;
  iccid: string | null;
}) {
  return axios.post(`${API_URL}catalogos/reanundacion-linea/validate`, {
    [msisdn ? 'msisdn' : 'iccid']: msisdn ? msisdn : iccid,
  });
}

export function reactivation({ msisdn }: { msisdn: string }) {
  return axios.post(`${API_URL}operation/reanundacion-linea`, {
    msisdn,
  });
}

export async function getAll(filters: any) {
  const response = await axios.get(`${API_URL}catalogos/reanundacion-linea`);
  const data = response.data.doc.data;
  return data;
}
